/**
 * @description The controller for the reset password component
 * @param {unknown} $state Unknown
 * @param {unknown} ResetPasswordFactory The service to send the reset
 * password request and password change
 * @param {library} _ The Lodash libray
 */
function ResetPasswordController(
  $state,
  ResetPasswordFactory,
  _
) {
  let vm = this;

  vm.$onInit = function() {
    vm.reset = false;
    vm.ResponseRecieved = false;

    // Public functions
    vm.sendResetEmail = sendResetEmail;
    vm.sendNewPassword = sendNewPassword;

    if (!_.isUndefined($state.params.uid) &&
    !_.isUndefined($state.params.token)) {
      vm.reset = true;
    }
  };

/**
 * @description Enter your email address and send a password reset request
 * @param {object} email The address to send the password reset confirmation
 * email to
 */
  function sendResetEmail(email) {
    ResetPasswordFactory.sendResetEmail(email).then(function(response) {
      if (response) {
        vm.ResponseRecieved = true;
      }
    });
  }

/**
 * @description Enter a new password and confirmation to update your account
 * password
 * @param {object} request The object containing the new password, and confirmed
 * password
 */
  function sendNewPassword(request) {
    request.uid = $state.params.uid;
    request.token = $state.params.token;
    ResetPasswordFactory.sendNewPassword(request);
  }
}

angular
  .module('inkfinder')
  .controller('ResetPasswordController', ResetPasswordController);



// WEBPACK FOOTER //
// ./components/reset-password/reset-password.controller.js